import { selectSelectedTempoElement } from "@/store/iframeSlice";
import { selectMultiSelectedTempoElements } from "@/store/iframeSlice";
import { useTypedSelector } from "@/store/store";
import { useCodebaseStore } from "@/store/zustand/codebaseStore";
import { TempoElement } from "@/utils/tempoElement";
import { useActiveCanvas } from "@/utils/utils";

export const useSelectedElements = () => {
  const selectedElement = useTypedSelector(selectSelectedTempoElement);
  const multiselectedElements = useTypedSelector<TempoElement[]>(
    selectMultiSelectedTempoElements
  );
  const treeElementLookup = useCodebaseStore(
    (state) => state.treeElementLookup
  );

  const elements = multiselectedElements?.length
    ? multiselectedElements
    : [selectedElement];

  const treeElements = elements.map(
    (element) => treeElementLookup[element.codebaseId]
  );

  const storyboardIds = elements
    .filter((element) => element.isStoryboard())
    .map((element) => element.storyboardId);

  const activeCanvas = useActiveCanvas();
  const storyboards =
    activeCanvas?.storyboards?.filter((storyboard) =>
      storyboardIds.includes(storyboard.id)
    ) || [];

  return {
    selectedElements: elements.filter(Boolean),
    selectedTreeElements: treeElements.filter(Boolean),
    selectedStoryboards: storyboards.filter(Boolean),
  };
};
